import React, { Component } from 'react'

import { connect } from 'react-redux'
import Loader from 'components/loader/loader'

import {
    changeTitle,
    getPlanAndCurrencyInfo,
    saveBillingDetails,
    openModal,
    validateCoupon
} from 'state/actions'

import {
	getCurrentAccount
} from 'state/selectors'

import { withRouter } from 'react-router'
import Button from 'components/button/button'
import copy from 'fast-copy'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import { CardElement, injectStripe } from 'react-stripe-elements'

import SmoothCollapse from 'react-smooth-collapse'
import Icon from 'components/icon/icon'
import Checkbox from 'components/input/checkbox'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import {
    getAllCountries,
    getTotalAccountCharge,
    getTrialEndDate,
    isBlockedPremiumAccount,
    isMobile
} from 'utils'

import yup from 'yup'
import moment from 'moment'

class BillingForm extends Component {

    state = {
        isLoading: false,
        saveSuccess: false,
        error: null,
        billing_company_name: '',
        billing_address: '',
        billing_city: '',
        billing_state: '',
        billing_postcode: '',
        billing_country: '',
        billing_is_annual: false,
        showingCardDetails: false,
        name: '',
        coupon_code: '',
        isEdit: false,
        discountPercent: 0,
        discountMonths: 0
    }

    inputRefs = []
    hasReceivedAccountData = false
    forceOpenCardDetails = false
    hasAnnualQuery = false

    componentWillMount() {
        const {
            userData,
            accountData,
            getPlanAndCurrencyInfo,
            planAndCurrencyData,
        } = this.props

        if (planAndCurrencyData) {
            this.setState({
                ...planAndCurrencyData,
                billing_country: planAndCurrencyData.country
            })
        } else {
            getPlanAndCurrencyInfo(response => {
                this.setState({
                    ...response,
                    billing_country: response.country
                })
            })
        }

        setTimeout(_ => {
            if (userData || accountData) {
                this.setUserAndAccountData()
            }
        }, 1)
    }

    componentDidMount() {
        const {
            selectedFrequency
        } = this.props

        if (selectedFrequency && selectedFrequency == 'annually') {
            this.hasAnnualQuery = true
        }
    }

    componentDidUpdate = prevProps => {
        const {
            userData,
            accountData,
            changeTitle,
            affiliate
        } = this.props

        if ((userData && !prevProps.userData) || (accountData && !prevProps.accountData)) {
            this.setUserAndAccountData()
        }

        if (affiliate && !prevProps.affiliate) {
            this.handleChange({
                target: {
                    value: 'AFFILIATE10'
                }
            }, 'coupon_code')
        }

        if (this.props.isActive && !prevProps.isActive) {
            changeTitle('Upgrade your plan')
        }
    }

    setUserAndAccountData = _ => {
        const tempState = copy(this.state)

        const {
            userData,
            accountData,
        } = this.props

        if (userData) {
            tempState.name = `${userData.first_name} ${userData.last_name}`
        }

        if (accountData && !this.hasReceivedAccountData) {
            this.hasReceivedAccountData = true

            tempState.billing_company_name = accountData.name

            if (accountData.billing_address) {
                tempState.billing_address = accountData.billing_address
            }

            if (accountData.billing_city) {
                tempState.billing_city = accountData.billing_city
            }

            if (accountData.billing_state) {
                tempState.billing_state = accountData.billing_state
            }

            if (accountData.billing_postcode) {
                tempState.billing_postcode = accountData.billing_postcode
            }

            if (accountData.billing_country) {
                tempState.billing_country = accountData.billing_country
            }

            if (accountData.billing_is_annual) {
                tempState.billing_is_annual = accountData.billing_is_annual
            }

            if (accountData.isPremium && !accountData.isOnGracePeriod) {
                tempState.isEdit = true
            }

            if (accountData.coupon_percent_off) {
                tempState.discountPercent = accountData.coupon_percent_off
            }

            if (accountData.coupon_code) {
                tempState.coupon_code = accountData.coupon_code
            }

            if(accountData.card_last_four){
                tempState.showingCardDetails = true
            }

            if ((!accountData.isPremium && !accountData.isOnGracePeriod && accountData.has_had_trial_already) || isBlockedPremiumAccount(accountData)) {
                this.forceOpenCardDetails = true
                tempState.showingCardDetails = true
            }
        }

        if (this.hasAnnualQuery) {
            tempState.billing_is_annual = 1
        }

        this.setState(tempState)
    }

    handleChange = (event, input) => {
        const {
            validateCoupon,
            handleError,
            accountData
        } = this.props

        const {
            discountPercent,
        } = this.state

        if (input === 'coupon_code') {
            const value = event.target.value

            if (value.length >= 5) {
                validateCoupon(value, (response, testedCode) => {
                    if (testedCode === value) {
                        if (response) {
                            const newState = {
                                discountPercent: response.percent_off,
                                discountMonths: response.duration_in_months ? response.duration_in_months : 0
                            }

                            if (accountData && !accountData.stripe_id) {
                                newState.showingCardDetails = true
                            }

                            this.setState(newState)

                        } else {
                            this.setState({
                                discountPercent: null
                            })

                            handleError("Your coupon code seems invalid")
                        }
                    }
                })
            } else if (discountPercent) {
                this.setState({
                    discountPercent: null,
                    discountMonths: 0
                })
            }
        }

        switch (input) {
            case 'showingCardDetails':
                this.setState({
                    [input]: !this.state[input],
                })

                if (this.props.forceSetModalHeight) {
                    setTimeout(_ => {
                        this.props.forceSetModalHeight()
                    }, 300)
                }
                break
            default:
                // for drop-downs, it's not passing an event.
                let value = event.target ? event.target.value : event

                this.setState({
                    [input]: value
                })
                break
        }
    }

    handleSubmit = async _ => {
        const {
            handleError,
            saveBillingDetails,
            accountData,
            closeCallback,
            goToApp,
            stripe
        } = this.props

        const {
            showingCardDetails,
        } = this.state

        // if it's forced open, or you've opted to add 'em in.
        if (this.forceOpenCardDetails || showingCardDetails) {
            const validateParams = {
                billing_company_name: yup.string().required(`We'll need a company name first.`),
                billing_address: yup.string().required(`We'll need an address first.`),
                billing_city: yup.string().required(`We'll need you to enter a city first.`),
                billing_state: yup.string().required(`We'll need you to enter a state first.`),
            }

            const submissionSchema = yup.object().shape(validateParams)

            // Validate input fields against schema
            try {
                await submissionSchema.validate({ ...this.state })
            } catch (err) {
                return handleError(err.message)
            }
        }

        this.setState({
            isLoading: true
        })

        let token = null

        if (showingCardDetails) {
            const createTokenResponse = await stripe.createToken({ name: this.state.billing_company_name })

            token = createTokenResponse.token

            if (!token || !token.id) {
                this.setState({
                    isLoading: false
                })

                return handleError("There seems to be an issue with your payment details.")
            }
        }

        saveBillingDetails({
            ...this.state,
            user: this.props.userData,
            token_id: token ? token.id : null
        }, accountData.id, error => {
            if (error) {
                this.setState({
                    isLoading: false
                })

                if (error.response && error.response.data) {
                    handleError(error.response.data.message)
                } else {
                    return handleError("An unknown error has occurred.")
                }
            } else {
                this.setState({
                    showResponse: true,
                    responseMessage: 'Success!',
                    responseIcon: 'check',
                }, _ => {
                    setTimeout(_ => {
                        this.setState({
                            showResponse: false,
                            isLoading: false,
                        }, _ => {
                            if (closeCallback) {
                                closeCallback()
                            } else {
                                goToApp()
                            }
                        })
                    }, 1000)
                })
            }
        })
    }

    getTotalUsers = _ => {
        const {
            accountData
        } = this.props

        if (!accountData) {
            return 1
        }

        let totalUsers = 0

        accountData.users && accountData.users.forEach(userId => {
            // ignore guests, obvi
            if (!accountData.guestIds || !accountData.guestIds.includes(userId)) {
                totalUsers++
            }
        })

        return totalUsers
    }

    getTotalFigure = _ => {
        const {
            showingCardDetails,
            isEdit,
            discountPercent,
            billing_is_annual
        } = this.state

        const {
            accountData,
            planAndCurrencyData,
        } = this.props

        if (!planAndCurrencyData) {
            return null
        }

        const {
            symbol,
            currency
        } = planAndCurrencyData

        const _symbol = accountData.currency || symbol

        if (!showingCardDetails && !isEdit && (accountData && !accountData.isOnGracePeriod)) {
            return _symbol + '0.00'
        } else {
            let totalCharge = getTotalAccountCharge(accountData, planAndCurrencyData, discountPercent, billing_is_annual)

            if (_symbol == '$') {
                totalCharge += `<span class="currency">${currency}</span>`
            }

            return totalCharge
        }
    }

    getSingleUnitPrice = _ => {
        const {
            symbol,
            billing_is_annual
        } = this.state

        const {
            account
        } = this.props

        const value = billing_is_annual ? 60 : 6

        const _symbol = (account && account.currency) ? account.currency : symbol

        return _symbol+value
    }

    getTrialRemainderInfo = _ => {
        const {
            accountData
        } = this.props

        let trialEndMoment = null

        const trialEndDate = accountData ? getTrialEndDate(accountData) : null

        if (trialEndDate && accountData.isPremium) {
            trialEndMoment = moment(trialEndDate)
        } else {
            trialEndMoment = moment().add(30, 'days').startOf('day')
        }

        const daysLeftOfTrial = (trialEndMoment.startOf('day').diff(moment(), 'days') + 1)
        const billingDay = trialEndMoment

        const intervalString = this.getIntervalString(this.forceOpenCardDetails ? moment() : billingDay)

        return {
            daysLeftOfTrial,
            intervalString
        }
    }

    getDisclaimer = _ => {
        const {
            isEdit
        } = this.state

        const {
            accountData
        } = this.props

        if (accountData) {
            if (accountData.isOnGracePeriod) {
                return `This'll be billed on the ${moment(accountData.subscriptions[0].ends_at).format('Do of MMMM')}, when your subscription renews.`
            }

            const {
                daysLeftOfTrial,
                intervalString
            } = this.getTrialRemainderInfo()

            if (this.forceOpenCardDetails) {
                return `You'll be billed today, and renew on the ${intervalString}.`
            } else if (daysLeftOfTrial > 0) {
                return `You'll be billed in ${daysLeftOfTrial > 1 ? daysLeftOfTrial + ' days' : 'tomorrow'}, then on the ${intervalString}. You can cancel any time before this date.`
            } else {
                return `Your subscription is active, and is billed on the ${intervalString}.`
            }
        }

        return ''
    }

    getIntervalString = renewMoment => {
        const {
            billing_is_annual
        } = this.state

        if (billing_is_annual) {
            return `${renewMoment.format('Do of MMMM')} every year`
        } else {
            return `${renewMoment.format('Do')} of every month`
        }
    }

    getDiscountDuration = _ => {
        const {
            discountMonths
        } = this.state

        const {
            accountData
        } = this.props

        if (discountMonths) {
            return '(' + discountMonths + ' months)'
        }

        if (accountData && accountData.coupon_expiry) {
            const existingExpiryMoment = moment(accountData.coupon_expiry)

            if (existingExpiryMoment.isAfter(moment())) {
                if (existingExpiryMoment.isSame(moment(), 'year')) {
                    return '(ends ' + existingExpiryMoment.format('Do MMMM') + ')'
                } else {
                    return '(ends ' + existingExpiryMoment.format('Do MMMM, Y') + ')'
                }
            }
        }

        return null
    }

    render() {
        const {
            isNew,
            handleDismiss,
            validateResponse,
            goBack,
            accountData,
            userData,
            affiliate
        } = this.props

        const {
            isLoading,
            billing_company_name,
            billing_address,
            billing_city,
            billing_state,
            billing_postcode,
            billing_country,
            showingCardDetails,
            coupon_code,
            showResponse,
            responseIcon,
            responseMessage,
            isEdit,
            discountPercent,
            billing_is_annual
        } = this.state

        const {
            daysLeftOfTrial,
        } = this.getTrialRemainderInfo()

        let formClass = 'upgrade-container auth-fields'

        if (isLoading) {
            formClass += ' loading'
        }

        const inputs = [
            [{
                value: billing_company_name,
                key: 'billing_company_name',
                placeholder: "Company name",
                type: 'text'
            }], [{
                value: billing_address,
                key: 'billing_address',
                placeholder: "Address",
                type: 'text'
            }], [
                {
                    value: billing_city,
                    key: 'billing_city',
                    placeholder: 'City',
                    type: 'text'
                }, {
                    value: billing_state,
                    key: 'billing_state',
                    placeholder: "State",
                    type: 'text'
                }
            ], [
                {
                    value: billing_postcode,
                    key: 'billing_postcode',
                    placeholder: 'Postcode',
                    type: 'text'
                }, {
                    value: billing_country,
                    key: 'billing_country',
                    placeholder: 'Country',
                    type: 'select'
                }
            ]
        ]

        if (accountData && !accountData.coupon_percent_off && !affiliate) {
            inputs.push([{
                value: coupon_code,
                key: 'coupon_code',
                placeholder: 'Have a coupon code?',
                type: 'text',
                disabled: !!accountData.coupon_percent_off
            }])
        }

        const toggleTabs = [
			{
				name: 'Monthly',
			},{
				name: 'Annually (Save 20%!)'
			}
        ]

        let ctaLabel = (!accountData || !accountData.has_had_trial_already) ? 'Start free trial' : 'Upgrade now'

        if (this.forceOpenCardDetails || (accountData && accountData.isOnGracePeriod)) {
            ctaLabel = 'Resume now'
        }

        if (isEdit) {
            ctaLabel = 'Update details'
        }

        return (
            <form
                className={formClass}
                noValidate
                onSubmit={e => { e.preventDefault() }}
                onClick={_ => {
                    if (window.Keyboard && window.Keyboard.hide) {
                        window.Keyboard.hide()
                    }
                }}
            >
                {showResponse ? (
                    <div className="response-container">
                        <Icon name={responseIcon} />
                        <span>
                            {responseMessage}
                        </span>
                    </div>
                ) : (
                        <Loader visible={isLoading} />
                    )}
                <div
                    className="form-fields"
                    onKeyPress={e => { (e.key === 'Enter') ? this.handleSubmit() : null }}
                >
                    <div className="left">
                        {!showingCardDetails ?
                            <div className="empty-billing-container">
                                <img src={document.base + '/images/decoration/billing-corner.png'} />
                                <p>
                                    Add billing details and save 5%, forever.
                                </p>
                                <span>
                                    You won't be charged for {daysLeftOfTrial} days.
                                </span>
                            </div>
                            :
                            <React.Fragment>
                                <SmoothCollapse expanded={!!validateResponse}>
                                    <ValidateResponse
                                        dismissCallback={handleDismiss}
                                        response={validateResponse}
                                        timeout={5000}
                                    />
                                </SmoothCollapse>
                                <SmoothCollapse expanded={showingCardDetails}>
                                    <div>
                                        {inputs.map((inputGroup, index) => {
                                            let className = 'form-row'

                                            if (inputGroup.length > 1) {
                                                className += ' halves'
                                            }

                                            return (
                                                <div className={className} key={index}>
                                                    {inputGroup.map((input, inputIndex) => {
                                                        if (input.hidden) {
                                                            return null
                                                        }

                                                        if (input.type == 'select') {
                                                            return (
                                                                <DropdownMenu
                                                                    isObjects={true}
                                                                    selectableItems={getAllCountries()}
                                                                    selectedItemId={input.value}
                                                                    handleChange={value => { this.handleChange(value, input.key) }}
                                                                    parentType={'countrie'}
                                                                    key={inputIndex}
                                                                    emptyLabel={'Select country'}
                                                                />
                                                            )
                                                        }

                                                        return (
                                                            <input
                                                                key={inputIndex}
                                                                onClick={e => { e.stopPropagation() }}
                                                                onChange={e => { this.handleChange(e, input.key) }}
                                                                value={input.value}
                                                                type={input.type}
                                                                placeholder={input.placeholder}
                                                                disabled={!!input.disabled}
                                                            />
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })}
                                        <div className="credit-card-form">
                                            <CardElement style={{
                                                base: {
                                                    color: (userData && userData.show_dark_ui) ? 'white' : 'black',
                                                    fontFamily: '"Source Sans Pro", sans-serif',
                                                    fontSize: isMobile() ? '20px' : '16px',
                                                    fontSmoothing: 'antialiased',
                                                },
                                            }} />
                                        </div>
                                    </div>
                                </SmoothCollapse>
                            </React.Fragment>
                        }
                    </div>
                    <div className="right upgrade-form-totals">
                        {discountPercent ?
                            <ul className="rates-list subtitle">
                                <li>
                                    <span>
                                        Coupon code discount {this.getDiscountDuration()}
                                    </span>
                                    <span>
                                        -{discountPercent}%
                                    </span>
                                </li>
                            </ul>
                            : null}
                        <div className="totals-container">
                            <span>
                                Total charges
                            </span>
                            <span dangerouslySetInnerHTML={{ __html: this.getTotalFigure() }} />
                        </div>
                        {!this.forceOpenCardDetails && (!accountData || !accountData.card_last_four) &&
                            <div className="form-row">
                                <label className="domain-toggle" onClick={e => e.stopPropagation()}>
                                    <Checkbox
                                        isChecked={showingCardDetails}
                                        onChange={isChecked => { this.handleChange(isChecked, 'showingCardDetails') }}
                                    />
                                    <span>
                                        {(accountData && accountData.card_last_four) ? 'Add new billing details?' : 'Add billing details now?'}
                                    </span>
                                </label>
                            </div>
                        }
                        { showingCardDetails &&
                            <ul className="radio-toggle">
                                { toggleTabs.map((tab, index) => {
                                    const isActive = (!index && !billing_is_annual) || (index && billing_is_annual)

                                    return (
                                        <li
                                            className={isActive ? 'active' : null}
                                            onClick={_ => {this.handleChange(index, 'billing_is_annual')}}
                                            key={index}
                                        >
                                            { tab.name }
                                        </li>
                                    )
                                })}
                            </ul>
                        }
                        <SmoothCollapse expanded={!!(showingCardDetails || isEdit || (accountData && accountData.isOnGracePeriod))}>
                            <span className="subtitle">
                                {this.getDisclaimer()}
                            </span>
                        </SmoothCollapse>
                        <Button
                            size={'big'}
                            level={'high'}
                            callback={this.handleSubmit}
                            label={ctaLabel}
                            icon={'check'}
                        />
                        {isNew ?
                            <span
                                className="auth-swap"
                                onClick={goBack}
                            >
                                &lsaquo; Go back
                            </span>
                            : null
                        }
                    </div>
                </div>
            </form>
        )
    }
}

const mapStateToProps = state => {
    return {
        planAndCurrencyData: state.auth.planAndCurrencyData,
		account: getCurrentAccount(state)
    }
}

export default injectStripe(withRouter(connect(mapStateToProps, {
    changeTitle,
    getPlanAndCurrencyInfo,
    saveBillingDetails,
    openModal,
    validateCoupon
})(withValidateResponse(BillingForm))))


// WEBPACK FOOTER //
// ./src/components/billing-form/billing-form.jsx